import {
  ProjectDataStoreAction,
  ProjectDataStoreKind,
  ProjectDataStoreType,
} from './projectDataStore.types';

export const INITIAL_PROJECT_DATA: ProjectDataStoreType = {
  projectDetails: {
    id: '',
    projectName: '',
    country: '',
    sector: '',
    sector2: '',
    carrierType: '',
    year: 0,
    investment: 0,
    sourceOfFounds: '',
    projectNumber: 0,
    reportUrl: '',
    description: '',
    lessonsLearnt: [],
    picture: {
      imageAlt: '',
      imageSrc: '',
    },
    rating: {},
    outcome: {
      indicators: [{ status: '', value: '' }],
      targets: [],
    },
    impacts: {
      indicators: [{ status: '', value: '' }],
      targets: [],
    },
  },
  randomProjects: [],
  errorRandomProjects: false,
  errorProjectDetails: false,
};

const projectDataStore = (
  state: ProjectDataStoreType,
  action: ProjectDataStoreAction
): ProjectDataStoreType => {
  switch (action.type) {
    case ProjectDataStoreKind.UPDATE_PROJECT_DETAILS: {
      return { ...state, projectDetails: { ...action.payload } };
    }
    case ProjectDataStoreKind.UPDATE_RANDOM_PROJECTS: {
      return { ...state, randomProjects: [...action.payload] };
    }
    case ProjectDataStoreKind.UPDATE_PROJECT_DETAILS_ERROR: {
      return { ...state, errorProjectDetails: action.payload };
    }
    case ProjectDataStoreKind.UPDATE_RANDOM_PROJECTS_DETAILS_ERROR: {
      return { ...state, errorRandomProjects: true };
    }

    default:
      throw new Error();
  }
};

export default projectDataStore;
